
import moment from 'moment'
import { Component } from 'react'
import { connect } from 'react-redux'
import GeneralDocuments from 'shared_src/dictionaries/documents/GeneralDocuments'

import { withLegacyRouter } from '../../../../decorators'
import { toFHIR, fromFHIR } from '../../../../lib/Proxy/choicesDocument'
import { IGAO } from '../../../igao'
import * as Card from '../../../shared/card'
import CrudTable from '../../../shared/CrudTable'
import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'
import FriendlyDate from '../../../shared/Date/FriendlyDate'
import ConfirmationDeleteDialog from '../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import DocumentsForm from './form'

const tableDefinition = [
  {
    title: 'Date Uploaded',
    displayFn: ({ updated_at: updatedAt }) => <FriendlyDateTime datetime={updatedAt} />,
    sortBy: 'updated_at'
  },
  {
    title: 'Type',
    displayFn: v => {
        const code = v?.type?.code
        const fallback = v?.type?.display
      return GeneralDocuments.find(item => item.code === code)?.label || fallback
    }
  },
  {
    title: 'File Name',
      displayFn: v => v?.attachedFileMeta?.filename
  },
  {
    title: 'Document Creation Date',
    displayFn: ({ created }) => <FriendlyDate date={created} />,
    sortFn: (a, b) => {
      const aVal = moment(a.created).format()
      const bVal = moment(b.created).format()
      if (aVal > bVal) {
        return 1
      }
      if (aVal === bVal) {
        return 0
      }
      return -1
    }
  },
  {
    title: 'Description',
    displayFn: v => v.description
  }
]

class DocumentsGrid extends Component {
  constructor (props) {
    super(props)

    const {
      params: { id: patientId }
    } = this.props

    this.urls = {
      get: () =>
        `/patients/${patientId}/fhir/DocumentReference/_search?patient=${patientId}&_count=99999`,
      create: () => `/patients/${patientId}/fhir/DocumentReference`,
      update: entry =>
        `/patients/${patientId}/fhir/DocumentReference/${entry.id}`,
      delete: entry =>
        `/patients/${patientId}/fhir/DocumentReference/${entry.id}`
    }
    this.mapFns = {
      toForm: fromFHIR,
      toFhir: entry => toFHIR(entry, patientId)
    }
  }

  render () {
    const patientId = this.props.params.id
    return (
      <div className='main'>
        <Card.Card expandable>
          <Card.Header>
            <h2>General Documents</h2>
          </Card.Header>
          <Card.ExpandableWrapper style={{ padding: '0 1rem 1rem' }}>
            <CrudTable
              entryType='document'
              entrySet={patientId}
              tableDefinition={tableDefinition}
              urlFns={this.urls}
              mapFns={this.mapFns}
              form={DocumentsForm}
              initialValues={{ mPower: false }}
              additionalFormProps={{
                currentUser: this.props.currentUser,
                clientName: this.props.clientName,
                patientId: this.props.params.id
              }}
              deleteDialog={ConfirmationDeleteDialog}
              additionalDeleteDialogProps={{ prompt: 'Really delete?' }}
              sortOn={0}
              sortDir='desc'
            />
          </Card.ExpandableWrapper>
        </Card.Card>
        <IGAO path='general_documents' />
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  currentUser: redux.users.current_user,
    clientName: redux?.patient?.clientName
})

export default connect(mapStateToProps)(withLegacyRouter(DocumentsGrid))
